(function () {
  if (window.pdCatalogue) return;
  window.pdCatalogue = true;
  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  /* ---------- Rendu réaliste des articles ---------- */
  function hexRgb(h) { h = h.replace('#', ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); return [0, 2, 4].map(function (i) { return parseInt(h.substr(i, 2), 16); }); }
  function teinte(h, k) { // k > 0 éclaircit, k < 0 assombrit
    var c = hexRgb(h).map(function (v) { return Math.round(k > 0 ? v + (255 - v) * k : v * (1 + k)); });
    return 'rgb(' + c.join(',') + ')';
  }
  function sombre(h) { var c = hexRgb(h); return (0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]) < 140; }

  var TETES = {
    ronde: 'M50 6 C77 6 94 28 94 56 C94 86 74 108 50 108 C26 108 6 86 6 56 C6 28 23 6 50 6 Z',
    goutte: 'M50 4 C80 4 95 26 93 54 C91 84 72 104 50 110 C28 104 9 84 7 54 C5 26 20 4 50 4 Z',
    diamant: 'M50 2 C64 14 88 30 92 46 C95 72 76 100 50 110 C24 100 5 72 8 46 C12 30 36 14 50 2 Z'
  };
  var uid = 0;

  function grain(id, force) {
    return '<filter id="' + id + '" x="0" y="0" width="100%" height="100%"><feTurbulence type="fractalNoise" baseFrequency="1.4" numOctaves="2" seed="4"/>' +
      '<feColorMatrix type="matrix" values="0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 ' + force + ' 0"/><feComposite in2="SourceAlpha" operator="in"/></filter>';
  }
  function ombreSol(cx, cy, rx) {
    return '<ellipse cx="' + cx + '" cy="' + cy + '" rx="' + rx + '" ry="' + (rx * 0.13) + '" fill="url(#' + 'pdsol' + ')"/>';
  }
  var DEFS_SOL = '<radialGradient id="pdsol"><stop offset="0" stop-color="#0F2037" stop-opacity=".38"/><stop offset="1" stop-color="#0F2037" stop-opacity="0"/></radialGradient>';

  function raquette(d, c1, c2, protege) {
    var u = 'r' + (++uid), clair = !sombre(c1);
    var face = protege ? '#E9EFF4' : c1;
    var s = '<defs>' + DEFS_SOL +
      '<clipPath id="' + u + 'c"><path d="' + d + '"/></clipPath>' +
      '<linearGradient id="' + u + 'f" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="' + teinte(face, .28) + '"/><stop offset=".55" stop-color="' + face + '"/><stop offset="1" stop-color="' + teinte(face, -.35) + '"/></linearGradient>' +
      '<linearGradient id="' + u + 'b" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="' + teinte(c2, -.3) + '"/><stop offset=".45" stop-color="' + teinte(c2, .35) + '"/><stop offset="1" stop-color="' + teinte(c2, -.45) + '"/></linearGradient>' +
      '<linearGradient id="' + u + 'm" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#05101E"/><stop offset=".5" stop-color="#2A3B52"/><stop offset="1" stop-color="#05101E"/></linearGradient>' +
      '<radialGradient id="' + u + 's" cx=".32" cy=".24" r=".55"><stop offset="0" stop-color="#fff" stop-opacity=".55"/><stop offset=".4" stop-color="#fff" stop-opacity=".12"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
      '<pattern id="' + u + 'k" width="3" height="3" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><rect width="1.5" height="3" fill="' + (clair ? 'rgba(15,32,55,.05)' : 'rgba(255,255,255,.05)') + '"/></pattern>' +
      grain(u + 'g', .22) + '</defs>' +
      ombreSol(50, 170, 26) +
      // manche
      '<rect x="43" y="106" width="14" height="60" rx="5" fill="url(#' + u + 'm)"/>';
    for (var y = 112; y < 162; y += 6) s += '<path d="M43 ' + (y + 5) + ' L57 ' + y + '" stroke="' + teinte(c2, -.15) + '" stroke-width="2.4" opacity=".9"/>';
    s += '<rect x="42" y="160" width="16" height="7" rx="3" fill="#05101E"/>' +
      // pont (gorge)
      '<path d="M34 98 Q50 74 66 98 L60 108 Q50 92 40 108 Z" fill="url(#' + u + 'm)"/>' +
      // tête
      '<path d="' + d + '" fill="url(#' + u + 'f)"/>' +
      '<g clip-path="url(#' + u + 'c)"><rect width="100" height="112" fill="url(#' + u + 'k)"/><rect width="100" height="112" fill="#000" filter="url(#' + u + 'g)" opacity=".5"/>';
    for (var yy = 16; yy < 104; yy += 8.5) {
      for (var x = 11 + (Math.round(yy / 8.5) % 2) * 4.25; x < 92; x += 8.5) {
        s += '<circle cx="' + x.toFixed(1) + '" cy="' + yy.toFixed(1) + '" r="1.9" fill="rgba(5,16,30,.55)"/>' +
          '<circle cx="' + x.toFixed(1) + '" cy="' + (yy + 0.6).toFixed(1) + '" r="1.25" fill="' + teinte(face, -.55) + '"/>';
      }
    }
    if (protege) s += '<path d="' + d + '" fill="none" stroke="' + c1 + '" stroke-width="14" stroke-dasharray="118 400" stroke-dashoffset="59" opacity=".92"/>';
    s += '<rect width="100" height="112" fill="url(#' + u + 's)"/></g>' +
      // cadre
      '<path d="' + d + '" fill="none" stroke="url(#' + u + 'b)" stroke-width="5.5"/>' +
      '<path d="' + d + '" fill="none" stroke="rgba(255,255,255,.35)" stroke-width=".8" transform="translate(50 57) scale(.945) translate(-50 -57)"/>' +
      '<path d="' + d + '" fill="none" stroke="rgba(5,16,30,.35)" stroke-width=".8"/>';
    return { vb: '0 0 100 176', zoom: '16 2 68 62', corps: s };
  }

  function sac(c1, c2, dos) {
    var u = 's' + (++uid);
    var defs = '<defs>' + DEFS_SOL +
      '<linearGradient id="' + u + 'f" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + teinte(c1, .22) + '"/><stop offset=".6" stop-color="' + c1 + '"/><stop offset="1" stop-color="' + teinte(c1, -.4) + '"/></linearGradient>' +
      '<linearGradient id="' + u + 'p" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + teinte(c1, .08) + '"/><stop offset="1" stop-color="' + teinte(c1, -.5) + '"/></linearGradient>' +
      '<linearGradient id="' + u + 'h" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#2A3B52"/><stop offset="1" stop-color="#05101E"/></linearGradient>' +
      '<radialGradient id="' + u + 's" cx=".3" cy=".1" r=".7"><stop offset="0" stop-color="#fff" stop-opacity=".32"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
      grain(u + 'g', .35) + '</defs>';
    if (!dos) {
      return { vb: '0 0 170 122', zoom: '22 34 84 52', corps: defs + ombreSol(85, 114, 70) +
        '<path d="M56 34 C56 8 114 8 114 34" fill="none" stroke="url(#' + u + 'h)" stroke-width="8" stroke-linecap="round"/>' +
        '<rect x="8" y="30" width="154" height="78" rx="34" fill="url(#' + u + 'f)"/>' +
        '<rect x="8" y="30" width="154" height="78" rx="34" fill="#000" filter="url(#' + u + 'g)" opacity=".55"/>' +
        '<path d="M26 48 L144 48" stroke="#05101E" stroke-width="3" stroke-linecap="round" opacity=".55"/>' +
        '<path d="M26 48 L144 48" stroke="' + c2 + '" stroke-width="1.6" stroke-dasharray="1.6 1.4"/>' +
        '<rect x="144" y="43" width="9" height="11" rx="2.5" fill="' + c2 + '"/>' +
        '<rect x="58" y="62" width="54" height="30" rx="10" fill="url(#' + u + 'p)" stroke="' + teinte(c2, -.1) + '" stroke-width="1.4"/>' +
        '<path d="M64 70 L106 70" stroke="' + c2 + '" stroke-width="1.2" stroke-dasharray="1.4 1.2"/>' +
        '<rect x="8" y="30" width="154" height="78" rx="34" fill="url(#' + u + 's)"/>' +
        '<path d="M42 32 Q85 26 128 32" fill="none" stroke="rgba(255,255,255,.4)" stroke-width="1.2"/>' };
    }
    return { vb: '0 0 120 166', zoom: '24 52 72 56', corps: defs + ombreSol(60, 158, 50) +
      '<path d="M40 24 C40 6 80 6 80 24" fill="none" stroke="url(#' + u + 'h)" stroke-width="7" stroke-linecap="round"/>' +
      '<path d="M18 40 Q14 22 34 20 L86 20 Q106 22 102 40 L104 128 Q104 150 80 150 L40 150 Q16 150 16 128 Z" fill="url(#' + u + 'f)"/>' +
      '<path d="M18 40 Q14 22 34 20 L86 20 Q106 22 102 40 L104 128 Q104 150 80 150 L40 150 Q16 150 16 128 Z" fill="#000" filter="url(#' + u + 'g)" opacity=".55"/>' +
      '<path d="M17 62 C42 52 78 52 103 62" fill="none" stroke="#05101E" stroke-width="3" opacity=".5"/>' +
      '<path d="M17 62 C42 52 78 52 103 62" fill="none" stroke="' + c2 + '" stroke-width="1.6" stroke-dasharray="1.6 1.4"/>' +
      '<rect x="30" y="82" width="60" height="52" rx="16" fill="url(#' + u + 'p)" stroke="' + teinte(c2, -.1) + '" stroke-width="1.4"/>' +
      '<path d="M40 90 L80 90" stroke="' + c2 + '" stroke-width="1.3" stroke-dasharray="1.4 1.2"/>' +
      '<rect x="56" y="86" width="8" height="10" rx="2" fill="' + c2 + '"/>' +
      '<path d="M18 40 Q14 22 34 20 L86 20 Q106 22 102 40 L104 128 Q104 150 80 150 L40 150 Q16 150 16 128 Z" fill="url(#' + u + 's)"/>' };
  }

  function balle(u, cx, cy, r, jaune) {
    return '<g><circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="url(#' + u + 'b)"/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="#000" filter="url(#' + u + 'g)" opacity=".7"/>' +
      '<path d="M' + (cx - r * .92) + ' ' + (cy - r * .25) + ' C' + (cx - r * .4) + ' ' + (cy + r * .45) + ' ' + (cx + r * .4) + ' ' + (cy + r * .45) + ' ' + (cx + r * .92) + ' ' + (cy - r * .25) + '" fill="none" stroke="rgba(5,16,30,.25)" stroke-width="3.2"/>' +
      '<path d="M' + (cx - r * .92) + ' ' + (cy - r * .25) + ' C' + (cx - r * .4) + ' ' + (cy + r * .45) + ' ' + (cx + r * .4) + ' ' + (cy + r * .45) + ' ' + (cx + r * .92) + ' ' + (cy - r * .25) + '" fill="none" stroke="#F8F8EE" stroke-width="2"/>' +
      '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="url(#' + u + 's)"/></g>';
  }

  function balles(c1, c2) {
    var u = 'b' + (++uid);
    var s = '<defs>' + DEFS_SOL +
      '<radialGradient id="' + u + 'b" cx=".36" cy=".32" r=".75"><stop offset="0" stop-color="' + teinte(c2, .35) + '"/><stop offset=".55" stop-color="' + c2 + '"/><stop offset="1" stop-color="' + teinte(c2, -.45) + '"/></radialGradient>' +
      '<radialGradient id="' + u + 's" cx=".3" cy=".25" r=".35"><stop offset="0" stop-color="#fff" stop-opacity=".45"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient>' +
      '<linearGradient id="' + u + 't" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="rgba(255,255,255,.55)"/><stop offset=".18" stop-color="rgba(255,255,255,.08)"/><stop offset=".72" stop-color="rgba(255,255,255,.02)"/><stop offset=".84" stop-color="rgba(255,255,255,.4)"/><stop offset="1" stop-color="rgba(255,255,255,.1)"/></linearGradient>' +
      '<linearGradient id="' + u + 'c" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="' + teinte(c1, -.4) + '"/><stop offset=".4" stop-color="' + teinte(c1, .25) + '"/><stop offset="1" stop-color="' + teinte(c1, -.5) + '"/></linearGradient>' +
      grain(u + 'g', .5) + '</defs>' + ombreSol(40, 170, 30) +
      '<rect x="12" y="10" width="56" height="156" rx="14" fill="rgba(200,215,228,.35)"/>';
    [40, 84, 128].forEach(function (cy) { s += balle(u, 40, cy, 22); });
    s += '<rect x="12" y="10" width="56" height="156" rx="14" fill="url(#' + u + 't)" stroke="rgba(15,32,55,.35)" stroke-width="1.2"/>' +
      '<rect x="9" y="2" width="62" height="16" rx="6" fill="url(#' + u + 'c)"/>' +
      '<rect x="9" y="14" width="62" height="3" fill="rgba(0,0,0,.2)"/>';
    return { vb: '0 0 80 178', zoom: '12 16 56 50', corps: s };
  }

  function grips(c1, c2) {
    var u = 'g' + (++uid), cols = [c1, c2, '#F4F7FA'];
    var s = '<defs>' + DEFS_SOL + grain(u + 'g', .4);
    cols.forEach(function (c, i) {
      s += '<radialGradient id="' + u + i + '" cx=".38" cy=".34" r=".7"><stop offset="0" stop-color="' + teinte(c, .3) + '"/><stop offset=".7" stop-color="' + c + '"/><stop offset="1" stop-color="' + teinte(c, -.45) + '"/></radialGradient>';
    });
    s += '</defs>' + ombreSol(72, 112, 62);
    [[36, 66], [72, 58], [108, 66]].forEach(function (p, i) {
      var cx = p[0], cy = p[1];
      s += '<circle cx="' + cx + '" cy="' + (cy + 3) + '" r="26" fill="rgba(5,16,30,.25)"/>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="26" fill="url(#' + u + i + ')"/>' +
        '<circle cx="' + cx + '" cy="' + cy + '" r="26" fill="#000" filter="url(#' + u + 'g)" opacity=".5"/>';
      for (var r = 9; r < 25; r += 3.2) s += '<circle cx="' + cx + '" cy="' + cy + '" r="' + r + '" fill="none" stroke="rgba(5,16,30,.14)" stroke-width=".9"/>';
      s += '<circle cx="' + cx + '" cy="' + cy + '" r="7" fill="#05101E"/><circle cx="' + (cx - 1.5) + '" cy="' + (cy - 1.5) + '" r="3" fill="#2A3B52"/>' +
        '<path d="M' + (cx - 18) + ' ' + (cy - 14) + ' A23 23 0 0 1 ' + (cx + 6) + ' ' + (cy - 24) + '" fill="none" stroke="rgba(255,255,255,.5)" stroke-width="2" stroke-linecap="round"/>';
    });
    return { vb: '0 0 144 122', zoom: '44 28 56 56', corps: s };
  }

  function dessin(cat, forme, c1, c2) {
    if (cat === 'raquette') return raquette(TETES[forme] || TETES.ronde, c1, c2, false);
    if (cat === 'protege') return raquette(TETES.ronde, c1, c2, true);
    if (cat === 'sac') return sac(c1, c2, false);
    if (cat === 'sac-dos') return sac(c1, c2, true);
    if (cat === 'balles') return balles(c1, c2);
    return grips(c1, c2);
  }

  function svg(cat, forme, col, vue) {
    var d = dessin(cat, forme, col.c1, col.c2);
    return '<svg viewBox="' + (vue === 'detail' ? d.zoom : d.vb) + '" aria-hidden="true" focusable="false">' + d.corps + '</svg>';
  }

  // Objet en relief : plusieurs couches empilées donnent une épaisseur visible quand il pivote
  function relief(contenu, couches) {
    var h = '<span class="pd-3d">';
    for (var i = couches; i > 0; i--) h += '<span class="pd-3d__tranche" style="transform:translateZ(' + (-i * 1.1) + 'px)">' + contenu + '</span>';
    return h + '<span class="pd-3d__face">' + contenu + '</span></span>';
  }

  function lireColoris(txt) {
    var liste = (txt || '').split('|').map(function (p) {
      var x = p.split(':');
      return { nom: (x[0] || '').trim(), c1: (x[1] || '#1D4F91').trim(), c2: (x[2] || '#E4EE3C').trim() };
    }).filter(function (c) { return c.nom; });
    return liste.length ? liste : [{ nom: 'Standard', c1: '#1D4F91', c2: '#E4EE3C' }];
  }

  function pastilles(conteneur, coloris, actif, auChoix) {
    conteneur.innerHTML = '';
    if (coloris.length < 2) return;
    coloris.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pd-swatch';
      b.style.setProperty('--s1', c.c1);
      b.style.setProperty('--s2', c.c2);
      b.setAttribute('aria-label', 'Coloris ' + c.nom);
      b.setAttribute('aria-pressed', i === actif ? 'true' : 'false');
      b.addEventListener('click', function (e) { e.stopPropagation(); auChoix(i); });
      conteneur.appendChild(b);
    });
  }

  function inclinaison(zone, cible, force) {
    if (reduit) return;
    zone.addEventListener('pointermove', function (e) {
      var r = zone.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5, dy = (e.clientY - r.top) / r.height - 0.5;
      cible.style.setProperty('--rx', (-dy * force) + 'deg');
      cible.style.setProperty('--ry', (dx * force * 1.3) + 'deg');
      cible.style.setProperty('--gx', ((dx + 0.5) * 100) + '%');
      cible.style.setProperty('--gy', ((dy + 0.5) * 100) + '%');
    });
    zone.addEventListener('pointerleave', function () {
      cible.style.setProperty('--rx', '0deg');
      cible.style.setProperty('--ry', '0deg');
    });
  }

  function transition(maj) {
    if (document.startViewTransition && !reduit) document.startViewTransition(maj);
    else maj();
  }

  function initCatalogue(root) {
    if (root.dataset.pdInit) return;
    root.dataset.pdInit = '1';
    var fiche = root.querySelector('.pd-fiche');
    var cartes = Array.prototype.slice.call(root.querySelectorAll('.pd-cat__carte'));

    cartes.forEach(function (carte) {
      var item = JSON.parse(carte.querySelector('[data-pd-item]').textContent);
      item.liste = lireColoris(item.coloris);
      item.actif = 0;
      carte._item = item;
      var zone = carte.querySelector('[data-pd-svg]');
      function dessine() {
        if (item.photo) zone.innerHTML = '<img src="' + item.photo + '" alt="" loading="lazy">';
        else zone.innerHTML = relief(svg(item.categorie, item.forme, item.liste[item.actif], 'face'), 2);
      }
      dessine();
      var sw = carte.querySelector('[data-pd-swatches]');
      function choisir(i) {
        item.actif = i;
        zone.classList.add('is-change');
        setTimeout(function () { dessine(); zone.classList.remove('is-change'); }, reduit ? 0 : 140);
        pastilles(sw, item.liste, i, choisir);
      }
      pastilles(sw, item.liste, 0, choisir);
      var visuel = carte.querySelector('.pd-cat__visuel');
      inclinaison(visuel, carte.querySelector('.pd-tilt'), 16);
      visuel.addEventListener('click', function () { ouvrir(item); });
    });

    // Filtres
    var filtres = Array.prototype.slice.call(root.querySelectorAll('[data-filtre]'));
    filtres.forEach(function (f) {
      f.addEventListener('click', function () {
        var val = f.dataset.filtre;
        transition(function () {
          filtres.forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
          cartes.forEach(function (c) { c.hidden = !(val === 'tout' || c.dataset.famille === val); });
        });
      });
    });

    // Fiche rapide
    var scene = fiche.querySelector('[data-pd-scene]');
    var objet = fiche.querySelector('[data-pd-objet]');
    var vuesBox = fiche.querySelector('[data-pd-vues]');
    var courant = null, vue = 'face', angle = 0;
    var VUES = [{ id: 'face', nom: 'Face' }, { id: 'angle', nom: 'Trois-quarts' }, { id: 'detail', nom: 'Détail' }];

    function f(cle) { return fiche.querySelector('[data-pd-f="' + cle + '"]'); }

    function rendFiche() {
      var item = courant, col = item.liste[item.actif];
      if (item.photo && vue === 'face') objet.innerHTML = '<img src="' + item.photo + '" alt="' + item.nom + '">';
      else objet.innerHTML = vue === 'detail' ? svg(item.categorie, item.forme, col, 'detail') : relief(svg(item.categorie, item.forme, col, 'face'), 6);
      angle = vue === 'angle' ? -34 : 0;
      objet.style.setProperty('--angle', angle + 'deg');
      vuesBox.innerHTML = '';
      VUES.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'pd-vue';
        b.setAttribute('aria-pressed', v.id === vue ? 'true' : 'false');
        b.setAttribute('aria-label', 'Vue ' + v.nom);
        b.innerHTML = '<span class="pd-vue__img' + (v.id === 'angle' ? ' is-angle' : '') + '">' +
          svg(item.categorie, item.forme, col, v.id === 'detail' ? 'detail' : 'face') + '</span><span>' + v.nom + '</span>';
        b.addEventListener('click', function () { vue = v.id; rendFiche(); });
        vuesBox.appendChild(b);
      });
      f('coloris').textContent = col.nom;
      pastilles(f('swatches'), item.liste, item.actif, function (i) { item.actif = i; rendFiche(); });
    }

    function ouvrir(item) {
      courant = item; vue = 'face';
      f('nom').textContent = item.nom;
      f('prix').textContent = item.prix;
      f('description').textContent = item.description || item.accroche || '';
      var dl = f('specs'); dl.innerHTML = '';
      (item.specs || '').split('\n').forEach(function (ligne) {
        var i = ligne.indexOf(':');
        if (i < 1) return;
        var div = document.createElement('div');
        div.innerHTML = '<dt></dt><dd></dd>';
        div.firstChild.textContent = ligne.slice(0, i).trim();
        div.lastChild.textContent = ligne.slice(i + 1).trim();
        dl.appendChild(div);
      });
      var lien = f('lien');
      lien.hidden = !item.lien;
      if (item.lien) lien.href = item.lien;
      f('bientot').hidden = !!item.lien;
      rendFiche();
      if (fiche.showModal) fiche.showModal(); else fiche.setAttribute('open', '');
    }

    fiche.querySelector('.pd-fiche__fermer').addEventListener('click', function () { fiche.close(); });
    fiche.addEventListener('click', function (e) { if (e.target === fiche) fiche.close(); });

    // Glisser pour pivoter
    var depart = null, angleDepart = 0;
    scene.addEventListener('pointerdown', function (e) {
      depart = e.clientX; angleDepart = angle;
      scene.setPointerCapture(e.pointerId);
      objet.classList.add('is-drag');
    });
    scene.addEventListener('pointermove', function (e) {
      if (depart === null) return;
      angle = Math.max(-60, Math.min(60, angleDepart + (e.clientX - depart) * 0.45));
      objet.style.setProperty('--angle', angle + 'deg');
    });
    function lacher() {
      if (depart === null) return;
      depart = null;
      objet.classList.remove('is-drag');
    }
    scene.addEventListener('pointerup', lacher);
    scene.addEventListener('pointercancel', lacher);
  }

  function initTout() { document.querySelectorAll('.pd-cat').forEach(initCatalogue); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTout);
  else initTout();
  document.addEventListener('shopify:section:load', initTout);
})();
